import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import {
  configurationPane,
  displayPane,
  emoji,
  header,
  singleContainer,
  singleParagraph,
  doneButton,
} from "@components/onboarding-nux/onboarding-steps/onboarding-team-join-create-step/OnboardingTeamJoinCreateStep.styles";
import { navPane } from "@components/onboarding-nux/OnboardingNUX.styles";

export const fixedContainer: CSSProperties = {
  position: "fixed",
  display: "flex",
  backgroundColor: greys.paleGrey,
  overflow: "auto",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 10,
  "& > .inner-container": {
    position: "relative",
    maxWidth: 1200,
    maxHeight: 800,
    minWidth: 1200,
    minHeight: 700,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    background: greys.white,
    margin: "auto",
    width: "100%",
    height: "100%",

    "& > .nav-pane": navPane,
    "& > .split-step-wrapper": {
      display: "flex",
      flex: 1,
      overflow: "hidden",
    },
  },
};

export const styles = {
  fixedContainer,
  displayPane,
  configurationPane,
  emoji,
  singleContainer,
  singleParagraph,
  doneButton,
  header: {
    ...header,
    maxWidth: 400,
    marginTop: 0,
  },
};
